export const routesRapor = [
  {
    path: "/ogrenci_borc",
    name: "ogrenci_borc",
    component: () => import("@/views/ogrenci_borc/index.vue"),
    meta: {
      public: false,
      title: "Öğrenci Borç",
      yetki: { k: [1110002] },
    },
  },
  {
    path: "/rapor_egitmen_ders_devam",
    name: "rapor_egitmen_ders_devam",
    component: () => import("@/views/rapor_egitmen_ders_devam/index.vue"),
    meta: {
      public: false,
      title: "Eğitmen Ders Devam",
      yetki: { k: [1112002] },
    },
  },
  {
    path: "/rapor_ogrenci_ders_devam",
    name: "rapor_ogrenci_ders_devam",
    component: () => import("@/views/rapor_ogrenci_ders_devam/index.vue"),
    meta: {
      public: false,
      title: "Öğrenci Ders Devam",
      yetki: { k: [1113002] },
    },
  },
];
